import { REQUEST_PREOPEN_BASIC_CLAIM } from 'containers/BasicManagement/redux/constants';

export const requestPreOpenBasicClaim = (
  claimToPreOpen: any,
  successCallback: Function,
) => ({
  type: REQUEST_PREOPEN_BASIC_CLAIM,
  claimToPreOpen,
  successCallback,
});
